import React, { useContext } from 'react'
import { motion, AnimatePresence } from "framer-motion"

import Sidebar from './components/Sidebar'
import Basket from './components/Basket'

import { GlobalProvider } from './components/Context/Context'

import Flash from './components/Flash'
import {
  Switch,
  Route,
  useLocation,
  Redirect
} from "react-router-dom";

import AuthContext from './components/Context/AuthContext'
import { routes } from './router'

function App() {
  const { isLoggedIn } = useContext(AuthContext);
  const location = useLocation();

  return (
    <div className="wrapper">
        <GlobalProvider>
          <Sidebar />
            <AnimatePresence exitBeforeEnter>
              <Switch location={location} key={location.pathname}>
                {
                  routes.map(({path, component, redirection, connected}, index) => {
                    if(!!redirection && !isLoggedIn() && location.pathname === path) {
                      return (
                        <motion.div key={index} exit="undefined">
                          <Redirect to={redirection} />
                        </motion.div>
                      )
                    }
                    return (<Route exact component={component} path={path} key={index} />)
                  })
                }
              </Switch>
            </AnimatePresence>
          <Basket />
          <Flash />
        </GlobalProvider>
    </div>
  );
}

export default App;
